import React from 'react';
import { CheckCircle, Clock, AlertCircle, Calendar, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Tasks() {
  const tasks = [{
    id: 1,
    title: 'مراجعة التقارير المالية للربع الثالث',
    committee: 'لجنة المالية',
    assignedTo: 'محمد الهاشمي',
    deadline: '2023-09-15',
    status: 'completed'
  }, {
    id: 2,
    title: 'تحديث وثائق تأهيل الموظفين',
    committee: 'لجنة الموارد البشرية',
    assignedTo: 'عائشة المنصوري',
    deadline: '2023-09-20',
    status: 'pending'
  }, {
    id: 3,
    title: 'تنفيذ بروتوكولات الأمان الجديدة',
    committee: 'لجنة تقنية المعلومات',
    assignedTo: 'عمر الشامسي',
    deadline: '2023-09-10',
    status: 'delayed'
  }, {
    id: 4,
    title: 'إنهاء عقود الموردين',
    committee: 'لجنة المشتريات',
    assignedTo: 'فاطمة الزعابي',
    deadline: '2023-09-25',
    status: 'pending'
  }, {
    id: 5,
    title: 'إجراء تدقيق الجودة',
    committee: 'لجنة ضمان الجودة',
    assignedTo: 'أحمد الظاهري',
    deadline: '2023-09-05',
    status: 'completed'
  }];
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'completed':
        return <CheckCircle size={16} className="text-green-500" data-id="element-2175" />;
      case 'pending':
        return <Clock size={16} className="text-orange-500" data-id="element-2176" />;
      case 'delayed':
        return <AlertCircle size={16} className="text-red-500" data-id="element-2177" />;
      default:
        return null;
    }
  };
  const getStatusText = (status: string) => {
    switch (status) {
      case 'completed':
        return 'مكتملة';
      case 'pending':
        return 'معلقة';
      case 'delayed':
        return 'متأخرة';
      default:
        return status;
    }
  };
  const getStatusClass = (status: string) => {
    switch (status) {
      case 'completed':
        return 'bg-green-100 text-green-800';
      case 'pending':
        return 'bg-orange-100 text-orange-800';
      case 'delayed':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  return <div dir="rtl" data-id="element-2178">
      <div className="flex justify-between items-center mb-6" data-id="element-2179">
        <h1 className="text-2xl font-bold" data-id="element-2180">المهام والتوصيات</h1>
        <Link to="/tasks/add" className="px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors" data-id="element-2181">
          إضافة مهمة جديدة
        </Link>
      </div>
      <div className="bg-white rounded-lg shadow-sm mb-6 p-4" data-id="element-2182">
        <div className="flex items-center space-x-4" data-id="element-2183">
          <button className="px-4 py-2 bg-orange-500 text-white rounded-md ml-4" data-id="element-2184">
            جميع المهام
          </button>
          <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md ml-4" data-id="element-2185">
            المهام المسندة إلي
          </button>
          <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md ml-4" data-id="element-2186">
            المكتملة
          </button>
          <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md ml-4" data-id="element-2187">
            المعلقة
          </button>
          <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md" data-id="element-2188">
            المتأخرة
          </button>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-2189">
        <div className="overflow-x-auto" data-id="element-2190">
          <table className="w-full" data-id="element-2191">
            <thead data-id="element-2192">
              <tr className="bg-gray-50" data-id="element-2193">
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2194">
                  المهمة
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2195">
                  اللجنة
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2196">
                  مسندة إلى
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2197">
                  تاريخ الاستحقاق
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2198">
                  الحالة
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2199">
                  الإجراءات
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-2200">
              {tasks.map(task => <tr key={task.id} data-id="element-2201">
                  <td className="px-6 py-4" data-id="element-2202">
                    <div className="font-medium text-gray-900" data-id="element-2203">
                      {task.title}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2204">
                    <div className="flex items-center" data-id="element-2205">
                      <Users size={16} className="text-gray-500 ml-2" data-id="element-2206" />
                      <span data-id="element-2207">{task.committee}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2208">
                    {task.assignedTo}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2209">
                    <div className="flex items-center" data-id="element-2210">
                      <Calendar size={16} className="text-gray-500 ml-2" data-id="element-2211" />
                      <span data-id="element-2212">{task.deadline}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2213">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full items-center ${getStatusClass(task.status)}`} data-id="element-2214">
                      {getStatusIcon(task.status)}
                      <span className="mr-1" data-id="element-2215">{getStatusText(task.status)}</span>
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-2216">
                    <Link to={`/tasks/${task.id}`} className="text-orange-500 hover:text-orange-700 ml-3" data-id="element-2217">
                      عرض
                    </Link>
                    <Link to={`/tasks/${task.id}/edit`} className="text-orange-500 hover:text-orange-700" data-id="element-2218">
                      تعديل
                    </Link>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}